import { useIsAuthenticated } from '@/hooks/useIsAuthenticated';
import { getJoinableTeams } from '@/pages/api/scribeAPIV2';
import { toast } from '@heidi/design-system/toast';
import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useQueryUser } from './useQueryUser';

export const GET_CANDIDATE_TEAMS = 'getJoinableTeams';

export const useQuerySelfOnboardingTeams = () => {
  const { isAuthenticated } = useIsAuthenticated();
  const { data: user } = useQueryUser();
  return useQuery({
    queryKey: [GET_CANDIDATE_TEAMS],
    enabled: isAuthenticated && !!user && user.can_self_onboard_team,
    queryFn: async () => {
      try {
        const data = await getJoinableTeams();
        return data;
      } catch (error) {
        if (error instanceof AxiosError) {
          toast({
            tone: 'destructive',
            title: 'Error fetching candidate teams',
            description: error.message,
          });
        }
        throw error;
      }
    },
  });
};
